import { InsightType } from 'lib/apis/entity/insight';
import { useOwnTranslate } from 'lib/hooks/useOwnTranslate';
import { nFormatter } from 'lib/utils/helpers/numberFormat';

type Props = {
  marketStat: InsightType.Stat;
};

const HousePricesStat4x = ({ marketStat }: Props) => {
  const { t } = useOwnTranslate('global');
  return (
    <>
      <section className="rounded rounded-md lg:px-8 px-6 lg:py-12 py-10 flex flex-col items-center lg:gap-16 gap-8">
        <div className="flex flex-col items-center gap-3">
          <h2 className="lg:text-display-xs text-lg text-grey-900 font-bold">
            {marketStat.title}
          </h2>
          <p className="lg:text-xl text-sm text-grey-500">
            {marketStat.description}
          </p>
        </div>
        <div className="grid xl:grid-cols-2 grid-cols-1 gap-6 w-full">
          {marketStat.content.map((c, index) => (
            <h3
              className="col-span-1 flex flex-col-reverse xl:items-start items-center gap-3 xl:border-r-2 xl:border-t-0 first-of-type:border-t-0 xl:pr-6 pt-6 border-t-2 border-primary-600"
              key={`${index}_${c.orderId}`}
            >
              <span className="lg:text-md text-sm text-grey-500">
                {c?.statsKindPhrase?.concat(' ')}
              </span>
              <span className="xl:text-display-md lg:text-display-sm text-display-xs font-semiBold text-primary-600">
                {c?.value
                  ? nFormatter(c.value)
                    .toString()
                    .concat(' ')
                    .concat((c.symbol === 't' && t('toman')) || '')
                  : '--'}
              </span>
            </h3>
          ))}
        </div>
      </section>
    </>
  );
};

export default HousePricesStat4x;
